import React from 'react';
import { ClipLoader } from 'react-spinners';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <ClipLoader
        color="#3B82F6" // Tailwind blue-500
        size={50}
        aria-label="Loading Spinner"
      />
      <p className="text-gray-600 text-lg mt-4">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
